import { allUserRoles } from "constants/phase";
import React, { useMemo } from "react";
import { Navigate, useOutletContext } from "react-router-dom";

const RoleBasedRoute = ({ element, allowedRoles }) => {
  const { currentRole } = useOutletContext();

  const homePage = useMemo(() => {
    if (currentRole === allUserRoles.superAdmin) {
      return "/overview";
    }
    return "/dashboard";
  }, [currentRole]);

  let Element;
  if (typeof element === "function") {
    Element = element;
  } else if (element && element.type) {
    Element = element.type;
  } else {
    throw new Error("Invalid element prop provided to RoleBasedRoute.");
  }

  if (currentRole && allowedRoles.includes(currentRole)) {
    return <Element {...(element.props || {})} />;
  } else {
    return <Navigate to={homePage} replace />;
  }
};

export default RoleBasedRoute;
